import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../Buttons/BtnSubmit';
import {showAppLoader, hideAppLoader} from '../Loader/LoaderSlice';
import {getCustomerServicesAvailable} from './SubscribersListSlice';
import oopsImg from './images/oops.svg';
import Config from '../../../Config';
import Loader from '../LocalLoader/LocalLoader';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';

const SubscribersList = (props) => {
  const [isLoading, SetIsLoading] = useState(true);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.isFullAuthenticated) {
          async function getItems() {
            props.showAppLoader();
            await props.getCustomerServicesAvailable();
            SetIsLoading(false);
            props.hideAppLoader();
          }
          getItems();
        }
      }
    },
    [props.isFullAuthenticated]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.fatalError) {
          props.hideAppLoader();
        }
      }
    },
    [props.fatalError]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.subscribers.length == 1) {
          props.onClick(props.subscribers[0]);
        }
      }
    },
    [props.subscribers]
  );

  function clickSubscriber(subscriberNumber) {
    props.showAppLoader();
    props.onClick(subscriberNumber);
  }

  function goBackHome() {
    window.location.assign(Config.lobbyUrl);
  }

  function errorDisplay() {
    return isLoading == false && props.subscribers && props.subscribers.length == 0 ? (
      <div className='subscribersList-container'>
        <div className='headers-row'>
          {isLoading == false && props.fatalError == true ? (
            <h3 className='top-header'>רגע! זה היה לא צפוי, יש לנו תקלה</h3>
          ) : (
            <h3 className='top-header'>רק שנייה אנחנו מזהים שאין לכם מנוי סלולר</h3>
          )}
        </div>
        <div>
          <p>אם תרצו לדבר איתנו אנחנו זמינים ב*3132</p>
        </div>
        <Image style={{marginBottom: '20px', marginTop: '10px'}} src={oopsImg} alt='error' />
        <div style={{marginTop: '20px'}} className='btn-row'>
          <BtnSubmit text='הבנתי' onclick={() => goBackHome()} />
        </div>
      </div>
    ) : null;
  }

  function displayMobileBox() {
    if (props.subscribers && props.subscribers.length == 1) {
      return (
        <div className='loader-container'>
          <Loader />
        </div>
      );
    }
    return props.subscribers.map((item) => (
      <div key={item.subscriberNo} onClick={() => clickSubscriber(item.subscriberNo)} className='mobileBox'>
        {item.subscriberNo}
        <div className='arrow' onClick={() => redirect(item.subscriberNo)}></div>
      </div>
    ));
  }

  return isLoading == false && props.subscribers && props.subscribers.length > 0 && props.fatalError != true ? (
    <div className='subscribersList-container'>
      <div className='headers-row'>
        {props.subscribers && props.subscribers.length == 1 ? null : <h3 className='top-header'>על איזה מנוי מדובר?</h3>}
      </div>
      <div className='mobile-data-row'>{displayMobileBox()}</div>
    </div>
  ) : (
    errorDisplay()
  );
};

const mapStateToProps = (state) => ({
  subscribers: state.subscribersList.subscribers,
  fatalError: state.subscribersList.fatalError,
  isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
});

const mapDispatchToProps = {
  getCustomerServicesAvailable,
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscribersList);
